import Lenis from 'https://cdn.jsdelivr.net/npm/lenis@1.1.20/dist/lenis.mjs';

(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lowPower =
    Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;

  if (reducedMotion || lowPower) return;

  const OVERLAY_SCROLL_SELECTOR = [
    '[data-lenis-prevent]',
    'dialog[open]',
    'details[scroll-lock][open]',
    'scroll-hint',
    '.menu-drawer',
    '.facets__panel[open] .facets__panel-content',
    '.predictive-search-form__content',
    '.quick-add-modal__content',
  ].join(', ');

  const lenis = new Lenis({
    lerp: 0.1,
    duration: 1.2,
    easing: (t) => 1 - Math.pow(1 - t, 4),
    smoothWheel: true,
    smoothTouch: false,
    wheelMultiplier: 1,
    touchMultiplier: 2,
    prevent: (node) => node instanceof Element && !!node.closest(OVERLAY_SCROLL_SELECTOR),
  });

  window.__xoLenis = lenis;
  document.documentElement.classList.add('lenis');

  let lockCount = 0;
  let scrollLockHeld = false;

  function lockLenis() {
    if (++lockCount === 1) lenis.stop();
  }

  function unlockLenis() {
    if (lockCount > 0 && --lockCount === 0) lenis.start();
  }

  function syncScrollLockAttribute() {
    const locked = document.documentElement.hasAttribute('scroll-lock');
    if (locked && !scrollLockHeld) {
      scrollLockHeld = true;
      lockLenis();
    } else if (!locked && scrollLockHeld) {
      scrollLockHeld = false;
      unlockLenis();
    }
  }

  // Pause Lenis while details-based overlays set html[scroll-lock].
  new MutationObserver(syncScrollLockAttribute).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['scroll-lock'],
  });
  syncScrollLockAttribute();

  // Pause Lenis while dialog-component overlays (cart, filters, search, quick-add) are open.
  // Capture is required — DialogOpenEvent/DialogCloseEvent do not bubble.
  document.addEventListener('dialog:open', lockLenis, true);
  document.addEventListener('dialog:close', unlockLenis, true);

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // View Transitions handshake — snapshot must be taken at scroll 0 to avoid
  // the new page rendering with stale offset and visibly jumping.
  window.addEventListener('pageswap', () => {
    lenis.stop();
    window.scrollTo(0, 0);
  });

  window.addEventListener('pagereveal', () => {
    if (lockCount === 0) lenis.start();
  });

  // Hash anchor links should use Lenis curve.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href');
    if (!id || id === '#') return;
    const target = document.querySelector(id);
    if (!target) return;
    event.preventDefault();
    lenis.scrollTo(target, { offset: -80 });
  });
})();
